import { render, staticRenderFns } from "./grade.vue?vue&type=template&id=f77051da&scoped=true"
import script from "./grade.vue?vue&type=script&lang=js"
export * from "./grade.vue?vue&type=script&lang=js"
import style0 from "./grade.vue?vue&type=style&index=0&id=f77051da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f77051da",
  null
  
)

export default component.exports